"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NucleusAlertTypes = void 0;
exports.NucleusAlertTypes = {
    MISC: "misc",
    MESSAGE: "message",
    BATTERY: "battery",
    DEVICE_OFFLINE: "deviceOffline",
    CALL_NOT_ANSWERED: "callNotAnswered",
    CALL_NOT_ESTABLISHED: "callNotEstablished",
    HOME: "home",
    BIOMETRIC: "biometric",
    BLE_DEVICES: "bleDevices"
};
// export type NucleusMessage = {
//   nucleusDataType: NucleusDataTypeName,
// }
